import axios from 'axios';
import { API_BASE_URL } from '../config/api.config';

export interface Device {
  id: number;
  device_id: string;
  device_name: string;
  device_type: 'desktop' | 'mobile' | 'tablet';
  browser: string;
  os: string;
  is_primary: boolean;
  created_at: string;
  last_seen: string;
}

export interface DeviceWithKey extends Device {
  public_key: string;
}

/**
 * Register a new device
 */
export async function registerDevice(deviceInfo: {
  deviceId: string;
  deviceName: string;
  deviceType: string;
  browser: string;
  os: string;
  publicKey: string;
  isPrimary?: boolean;
}) {
  const response = await axios.post(
    `${API_BASE_URL}/api/devices/register`,
    deviceInfo,
    { withCredentials: true }
  );
  return response.data;
}

/**
 * Get all devices for current user
 */
export async function getMyDevices() {
  const response = await axios.get(
    `${API_BASE_URL}/api/devices`,
    { withCredentials: true }
  );
  return response.data;
}

/**
 * Get all devices with public keys for a specific user (family member)
 */
export async function getUserDevices(userId: string) {
  const response = await axios.get(
    `${API_BASE_URL}/api/devices/user/${userId}/keys`,
    { withCredentials: true }
  );
  return response.data;
}

/**
 * Delete a device
 */
export async function deleteDevice(deviceId: string) {
  const response = await axios.delete(
    `${API_BASE_URL}/api/devices/${deviceId}`,
    { withCredentials: true }
  );
  return response.data;
}

/**
 * Set a device as primary
 */
export async function setPrimaryDevice(deviceId: string) {
  const response = await axios.put(
    `${API_BASE_URL}/api/devices/${deviceId}/primary`,
    {},
    { withCredentials: true }
  );
  return response.data;
}

/**
 * Generate a pairing token for QR code
 */
export async function generatePairingToken(deviceId: string, publicKey: string) {
  const response = await axios.post(
    `${API_BASE_URL}/api/devices/pairing-token`,
    { deviceId, publicKey },
    { withCredentials: true }
  );
  return response.data;
}

/**
 * Pair a new device using a token
 */
export async function pairDevice(params: {
  token: string;
  deviceId: string;
  deviceName: string;
  deviceType: string;
  browser: string;
  os: string;
  publicKey: string;
}) {
  const response = await axios.post(
    `${API_BASE_URL}/api/devices/pair`,
    params,
    { withCredentials: true }
  );
  return response.data;
}
